export default __webpack_public_path__ + "static/light-green-4ad5e51726a5795aa8f47278fea6927a.png";